import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full py-10 text-center text-slate-400 text-sm border-t border-slate-200 mt-24 bg-white/50 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4">
        <p className="font-medium">{t('app.footer', { year: new Date().getFullYear() })}</p>
        <div className="flex gap-6">
          <Link to="/privacy-policy" className="hover:text-slate-600 transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="hover:text-slate-600 transition-colors">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};
